import React, { useState, useEffect } from 'react';
import useGlobal from '../../store';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';


const SelectUser = (props) => {
    
    const [giftlists] = useGlobal(
        state => state.giftlists
    );
    const [user] = useGlobal(
        state => state.user
    );

    const buildAvatarUrl = (userData) => {
        if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && (userData.avatarFile.indexOf('_avatar') > 0 || userData.avatarFile.length > 30)) {
	        return "https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2";
	    }
	    if(userData.FBID && userData.FBID !== "0") {
	        return "https://graph.facebook.com/" + userData.FBID + "/picture?type=large";
	    }
	    if(userData.hasOwnProperty('avatarFile') && userData.avatarFile) {
	        return "https://weblight.imgix.net/avatars/"+userData.avatarFile;
	    }
	    return "https://weblight.imgix.net/avatars/man.png";
    }

    const [selectedUser, setSelectedUser] = useState(<></>);

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen(prevState => !prevState);
    
    const myoption = <div className="btn-block p-2 hover-cursor user-option" onClick={() => chooseUser(user)}>
                         <img alt="" src={buildAvatarUrl(user)}  style={{height: "30px", borderRadius: "50%"}} className="mr-2" />
                        {user.FirstName} {user.LastName}</div>;
    const options = giftlists.map(gl => <div key={gl.userID} className="btn-block p-2 hover-cursor user-option" onClick={() => chooseUser(gl)}>
                <img alt="" src={buildAvatarUrl(gl)} style={{height: "30px", borderRadius: "50%"}} className="mr-2" />
                {gl.FirstName} {gl.LastName}
            </div>);

    const chooseUser = (chosenUser) => {
        setSelectedUser(<span className="p-2">
            <img alt="" src={buildAvatarUrl(chosenUser)}  style={{height: "30px", borderRadius: "50%"}} className="mr-2" />
            {chosenUser.FirstName} {chosenUser.LastName}</span>);
        props.onChange(chosenUser);
        toggle();
    }

    useEffect(() => {
        if(props.selectedUser) {
            setSelectedUser(<span className="p-2">
                <img alt="" src={buildAvatarUrl(props.selectedUser)}  style={{height: "30px", borderRadius: "50%"}} className="mr-2" />
                {props.selectedUser.FirstName} {props.selectedUser.LastName}</span>);
            return;
        } 
        setSelectedUser(<span className="p-2">
            <img alt="" src={buildAvatarUrl(user)}  style={{height: "30px", borderRadius: "50%"}} className="mr-2" />
            {user.FirstName} {user.LastName}</span>);
        props.onChange(user);
    }, [user, props]);

    return (
        <>
        <div className="btn-block"><label>This gift is for:</label>
        <Dropdown className="btn-block btn-success customer-user-select" isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle color="success" caret block>
                {selectedUser}
            </DropdownToggle>
            <DropdownMenu className="btn-block"
                modifiers={{
                    setMaxHeight: {
                      enabled: true,
                      order: 890,
                      fn: (data) => {
                        return {
                          ...data,
                          styles: {
                            ...data.styles,
                            overflow: 'auto',
                            maxHeight: '300px',
                          },
                        };
                      },
                    },
                  }}
            
            >
                {myoption}
                {options}
            </DropdownMenu>
        </Dropdown></div>
        </>);
}
export default SelectUser;